var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.25,
    height: 21.167,
    viewBox: "0 0 19.25 21.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-home",
    "data-name": "Icon feather-home",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8316",
    "data-name": "\\uD328\\uC2A4 8316",
    className: "cls-1",
    d: "M4.5,9.708,13.125,3,21.75,9.708V20.25a1.917,1.917,0,0,1-1.917,1.917H6.417A1.917,1.917,0,0,1,4.5,20.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8317",
    "data-name": "\\uD328\\uC2A4 8317",
    className: "cls-1",
    d: "M13.5,27.583h3.194V18",
    transform: "translate(-3.25 -5.417)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHome);
export default __webpack_public_path__ + "static/media/btn-home.0a6fce27d1b8d027710f969d6f498553.svg";
export { ForwardRef as ReactComponent };